import { useMemo } from "react";
import { matchPath, useLocation, type ParamParseKey, type PathMatch } from "react-router-dom";

export function matchAnyPath<S extends string>(
  paths: S[],
  pathname: string,
  end = false,
): PathMatch<ParamParseKey<S>> | null {
  for (const path of paths) {
    const match = matchPath({ path, end }, pathname);
    if (match) return match as PathMatch<ParamParseKey<S>>;
  }
  return null;
}

export function useMatchAny<S extends string>(paths: S[], end = false): PathMatch<ParamParseKey<S>> | null {
  const location = useLocation();
  return useMemo(() => matchAnyPath(paths, location.pathname, end), [paths, end, location.pathname]);
}
